//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

(function () {
  const curalate = angular.module('curalate');

  curalate.service('AccountSettingsService', [
    '$http',
    'PromiseService',
    function ($http, PromiseService) {
      const BASE_URL = '/api/settings';
      const USERS_URL = `${BASE_URL}/users`;
      const DOMAIN_URL = `${BASE_URL}/domain`;

      //
      // General User Settings
      //

      this.changeUserPassword = function (
        oldPassword,
        newPassword1,
        newPassword2,
      ) {
        const params = {
          oldPassword,
          newPassword1,
          newPassword2,
        };
        return PromiseService.processHttpResponse(
          $http.put(`${USERS_URL}/password`, params),
        );
      };

      this.getTimezones = function () {
        return PromiseService.processHttpResponse($http.get('/api/time-zones'));
      };

      this.updateTimezone = function (timeZoneId) {
        const params = { timeZoneId };
        return PromiseService.processHttpResponse(
          $http.put(`${USERS_URL}/timezone`, params),
        );
      };

      //
      // Domain Settings
      //

      this.getDomains = function () {
        return PromiseService.processHttpResponse($http.get(DOMAIN_URL));
      };

      this.addDomain = function (domain) {
        const params = {
          domain,
          id: -1, // dummy value
        };
        return PromiseService.processHttpResponse(
          $http.post(DOMAIN_URL, params),
          /* shouldGetErrorObject */ true,
        );
      };

      this.removeDomain = function (domain) {
        return PromiseService.processHttpResponse(
          $http.delete(`${DOMAIN_URL}/${domain.id}`),
        );
      };

      //
      // Employee Settings
      //

      this.getInternalView = function () {
        return PromiseService.processHttpResponse(
          $http.get(`${USERS_URL}/internal-view`),
        );
      };

      this.setInternalView = function (view) {
        const params = { view };
        return PromiseService.processHttpResponse(
          $http.put(`${USERS_URL}/internal-view`, params),
        );
      };

      this.getElevation = function () {
        return PromiseService.processHttpResponse(
          $http.get(`${USERS_URL}/elevate`),
        );
      };

      this.elevateUser = function (params) {
        return PromiseService.processHttpResponse(
          $http.post(`${USERS_URL}/elevate`, params),
        );
      };

      this.revokeUserElevation = function () {
        return PromiseService.processHttpResponse(
          $http.delete(`${USERS_URL}/elevate`),
        );
      };

      this.getProductCatalogs = function () {
        return PromiseService.processHttpResponse(
          $http.get(`${BASE_URL}/product-catalogs`),
        );
      };
    },
  ]);
})();
